import './DotLoading.less'
import DotLoading from './DotLoading'
export default DotLoading
